import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axios";

export default function ProtectedRoute(props) {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const checkUserToken = () => {
    axios.get('/check-token-expiry')
    .catch((error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('access-token');
      }
    });
    
    const userToken = localStorage.getItem('access_token');
    if (!userToken || userToken === 'undefined') {
      setIsLoggedIn(false);
      return navigate('/login');
    }
    setIsLoggedIn(true);
  }
  useEffect(() => {
    checkUserToken();
  }, [isLoggedIn]);

  return (
    <>
        {
          isLoggedIn ? props.children : null
        }
    </>
  )
}
